export default __webpack_public_path__ + "static/media/080_finish_soso.av1.894023aa.mp4";